module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('v-select', {
    attrs: {
      "items": _vm.plansList,
      "loading": _vm.loading.plans,
      "disabled": _vm.closed,
      "label": "Select plan",
      "return-object": "",
      "rules": _vm.required
    },
    on: {
      "change": _vm.changedPlan
    },
    model: {
      value: (_vm.selectedPlan),
      callback: function($$v) {
        _vm.selectedPlan = $$v
      },
      expression: "selectedPlan"
    }
  }), _vm._v(" "), (_vm.selectedPlan) ? _c('v-layout', {
    attrs: {
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('div', {
    staticClass: "selected"
  }, [_vm._v("Default casket: "), _c('span', {
    staticClass: "default-casket"
  }, [_vm._v(_vm._s(_vm.defaultCasket))])]), _vm._v(" "), _c('span', {
    staticClass: "arrow-right"
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [(_vm.selectedPlan) ? _c('v-select', {
    attrs: {
      "items": _vm.allCaskets,
      "disabled": _vm.closed,
      "label": "Select Casket Model",
      "clearable": "",
      "id": "selectCasket"
    },
    model: {
      value: (_vm.selectedCasket),
      callback: function($$v) {
        _vm.selectedCasket = $$v
      },
      expression: "selectedCasket"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedPlan && _vm.servicesList && _vm.servicesList.length > 0) ? _c('v-flex', [(_vm.selectedPlan && _vm.servicesList && _vm.servicesList.length > 0) ? _c('v-combobox', {
    attrs: {
      "items": _vm.filterProducts(_vm.servicesList),
      "loading": _vm.loading.services,
      "value": _vm.filterProducts(_vm.selectedServices),
      "disabled": _vm.closed,
      "label": "Select products",
      "item-value": "id",
      "item-text": "name",
      "filter": _vm.filter,
      "return-object": "",
      "multiple": "",
      "attach": "",
      "clearable": "",
      "hide-selected": "",
      "id": "selectProducts"
    },
    on: {
      "change": function($event) {
        return _vm.updateSelectedServices($event, 'product')
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n          Product: " + _vm._s(props.item.name) + " | Category: " + _vm._s(props.item.category.name) + "\n        ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n              " + _vm._s(props.item.name) + "\n            ")])])]
      }
    }], null, false, 4123951351)
  }) : _vm._e(), _vm._v(" "), (_vm.selectedPlan && _vm.servicesList && _vm.servicesList.length > 0) ? _c('v-combobox', {
    attrs: {
      "items": _vm.filterAddons(_vm.servicesList, 30),
      "loading": _vm.loading.services,
      "value": _vm.filterAddons(_vm.selectedServices, 30),
      "disabled": _vm.closed,
      "label": "Select Floral Add-Ons",
      "item-value": "id",
      "item-text": "name",
      "filter": _vm.filter,
      "return-object": "",
      "autofocus": "",
      "deletable-chips": "",
      "multiple": "",
      "clearable": "",
      "hide-selected": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateSelectedServices($event, 'add', 30)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n          " + _vm._s(props.item.name) + "\n        ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n              " + _vm._s(props.item.name) + "\n            ")])])]
      }
    }], null, false, 1524128383)
  }) : _vm._e(), _vm._v(" "), (_vm.selectedPlan && _vm.servicesList && _vm.servicesList.length > 0) ? _c('v-combobox', {
    attrs: {
      "items": _vm.filterAddons(_vm.servicesList, 31),
      "loading": _vm.loading.services,
      "value": _vm.filterAddons(_vm.selectedServices, 31),
      "disabled": _vm.closed,
      "label": "Select Services Add-Ons",
      "item-value": "id",
      "item-text": "name",
      "filter": _vm.filter,
      "return-object": "",
      "autofocus": "",
      "deletable-chips": "",
      "multiple": "",
      "clearable": "",
      "hide-selected": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateSelectedServices($event, 'add', 31)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n          " + _vm._s(props.item.name) + "\n        ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n              " + _vm._s(props.item.name) + "\n            ")])])]
      }
    }], null, false, 1524128383)
  }) : _vm._e(), _vm._v(" "), (_vm.selectedPlan && _vm.servicesList && _vm.servicesList.length > 0) ? _c('v-combobox', {
    attrs: {
      "items": _vm.filterAddons(_vm.servicesList, 32),
      "loading": _vm.loading.services,
      "value": _vm.filterAddons(_vm.selectedServices, 32),
      "disabled": _vm.closed,
      "label": "Select Add-On Items",
      "item-value": "id",
      "item-text": "name",
      "filter": _vm.filter,
      "return-object": "",
      "autofocus": "",
      "deletable-chips": "",
      "multiple": "",
      "clearable": "",
      "hide-selected": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateSelectedServices($event, 'add', 32)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n          " + _vm._s(props.item.name) + "\n        ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n              " + _vm._s(props.item.name) + "\n            ")])])]
      }
    }], null, false, 1524128383)
  }) : _vm._e(), _vm._v(" "), (_vm.selectedPlan && _vm.servicesList && _vm.servicesList.length > 0) ? _c('v-combobox', {
    attrs: {
      "items": _vm.filterAddons(_vm.servicesList, 33),
      "loading": _vm.loading.services,
      "value": _vm.filterAddons(_vm.selectedServices, 33),
      "disabled": _vm.closed,
      "label": "Select Food and Gift Add-Ons",
      "item-value": "id",
      "item-text": "name",
      "filter": _vm.filter,
      "return-object": "",
      "autofocus": "",
      "deletable-chips": "",
      "multiple": "",
      "clearable": "",
      "hide-selected": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateSelectedServices($event, 'add', 33)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n          " + _vm._s(props.item.name) + "\n        ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n              " + _vm._s(props.item.name) + "\n            ")])])]
      }
    }], null, false, 1524128383)
  }) : _vm._e(), _vm._v(" "), (_vm.selectedPlan && _vm.servicesList && _vm.servicesList.length > 0) ? _c('v-combobox', {
    attrs: {
      "items": _vm.filterAddons(_vm.servicesList, 34),
      "loading": _vm.loading.services,
      "value": _vm.filterAddons(_vm.selectedServices, 34),
      "disabled": _vm.closed,
      "label": "Select Logistics Add-Ons",
      "item-value": "id",
      "item-text": "name",
      "filter": _vm.filter,
      "return-object": "",
      "autofocus": "",
      "deletable-chips": "",
      "multiple": "",
      "clearable": "",
      "hide-selected": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateSelectedServices($event, 'add', 34)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n          " + _vm._s(props.item.name) + "\n        ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n              " + _vm._s(props.item.name) + "\n            ")])])]
      }
    }], null, false, 1524128383)
  }) : _vm._e(), _vm._v(" "), (_vm.selectedServices && _vm.selectedServices.length) ? _c('v-data-table', {
    attrs: {
      "items": _vm.selectedServices,
      "headers": _vm.productsTableHeaders,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('v-layout', {
          attrs: {
            "justify-space-between": "",
            "align-center": ""
          }
        }, [(_vm.upgrade_id === props.item.id) ? _c('v-combobox', {
          attrs: {
            "items": _vm.filteredProducts,
            "label": "Select Another Product from same category"
          },
          on: {
            "change": function($event) {
              return _vm.changeProductFromCategory(props.item)
            }
          },
          model: {
            value: (_vm.change_product_from_category_model),
            callback: function($$v) {
              _vm.change_product_from_category_model = $$v
            },
            expression: "change_product_from_category_model"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.upgrade_id !== props.item.id) ? _c('span', [_vm._v("\n                " + _vm._s(props.item.name) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.upgrade_id !== props.item.id && !_vm.closed) ? _c('v-btn', {
          attrs: {
            "small": "",
            "align-rigth": ""
          },
          on: {
            "click": function($event) {
              return _vm.upgradeCategory(props.item)
            }
          }
        }, [_vm._v("Upgrade")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('td', {
          staticClass: "quantity_bgcolor"
        }, [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.amount,
            "large": "",
            "lazy": "",
            "persistent": ""
          },
          on: {
            "update:returnValue": function($event) {
              return _vm.$set(props.item, "amount", $event)
            },
            "update:return-value": function($event) {
              return _vm.$set(props.item, "amount", $event)
            }
          },
          scopedSlots: _vm._u([{
            key: "input",
            fn: function() {
              return [_c('v-text-field', {
                attrs: {
                  "label": "Quantity",
                  "disabled": _vm.closed,
                  "single-line": "",
                  "autofocus": ""
                },
                model: {
                  value: (props.item.amount),
                  callback: function($$v) {
                    _vm.$set(props.item, "amount", $$v)
                  },
                  expression: "props.item.amount"
                }
              })]
            },
            proxy: true
          }], null, true)
        }, [_c('div', [_vm._v(_vm._s(props.item.amount))])])], 1), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.price))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.amount * props.item.price))]), _vm._v(" "), _c('td', {
          staticClass: "justify-center layout px-0"
        }, [(!_vm.closed) ? _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteItem(props.item)
            }
          }
        }, [_vm._v("\n              delete\n            ")]) : _vm._e()], 1)]
      }
    }], null, false, 3565082664)
  }, [_vm._v(" "), _c('template', {
    slot: "footer"
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Remarks in $",
      "type": "number",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.discount),
      callback: function($$v) {
        _vm.discount = $$v
      },
      expression: "discount"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    attrs: {
      "label": "Remarks in text",
      "outline": "",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.remarks),
      callback: function($$v) {
        _vm.remarks = $$v
      },
      expression: "remarks"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "tag": "h3"
    }
  }, [_vm._v("\n            Final price: $" + _vm._s(_vm.finalPrice) + "\n          ")])], 1)], 2) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-5": ""
    }
  }, [_c('h3', [_vm._v("Embalming Notes")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Tag number & other remarks",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.tagAndRemarks),
      callback: function($$v) {
        _vm.tagAndRemarks = $$v
      },
      expression: "tagAndRemarks"
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [(_vm.caseData && _vm.caseData.embalmer_photos) ? _c('div', {
    staticClass: "emb_images_container"
  }, _vm._l((_vm.caseData.embalmer_photos), function(embImage, key) {
    return _c('div', {
      key: key,
      staticClass: "emb_image_wrap"
    }, [_c('div', {
      staticClass: "removeImage",
      on: {
        "click": function($event) {
          return _vm.deleteImageWithConfirmation(embImage.id, key)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "emb_image",
      attrs: {
        "src": embImage.embalmer_photo_uri,
        "alt": embImage.embalmer_photo_caption
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.uploadPercentage !== 0 && _vm.uploadPercentage !== 100) ? _c('v-progress-linear', {
    attrs: {
      "value": _vm.uploadPercentage,
      "color": "light-blue"
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.closed) ? _c('v-btn', {
    staticClass: "mt-3 ml-0",
    attrs: {
      "color": "primary",
      "disabled": _vm.disabled.uploadPhotoForEmbalmersBtn,
      "loading": _vm.disabled.uploadPhotoForEmbalmersBtn,
      "prepend-icon": _vm.uploadStatus,
      "type": "file"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.inputUpload.click()
      }
    }
  }, [_vm._v("Upload Optional Photo\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.closed) ? _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "inputUpload",
    attrs: {
      "accept": "image/*, .jpg, .jpeg, .png",
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.onFileChange
    }
  }) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "bottom": "",
      "color": "success",
      "multi-line": "",
      "timeout": 2000
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("Photo uploaded!")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-5": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Preplan",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.isPreplan),
      callback: function($$v) {
        _vm.isPreplan = $$v
      },
      expression: "isPreplan"
    }
  }), _vm._v(" "), (!_vm.isPreplan) ? _c('h3', [_vm._v("Wake Dates")]) : _vm._e(), _vm._v(" "), (!_vm.isPreplan) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "id": "selectStartDate"
    },
    model: {
      value: (_vm.menuDateStart),
      callback: function($$v) {
        _vm.menuDateStart = $$v
      },
      expression: "menuDateStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select start date",
      "prepend-icon": "event",
      "readonly": "",
      "disabled": _vm.closed
    },
    slot: "activator",
    model: {
      value: (_vm.wakeDateStart),
      callback: function($$v) {
        _vm.wakeDateStart = $$v
      },
      expression: "wakeDateStart"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": "",
      "min": _vm.minStartDate,
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.wakeDateStart),
      callback: function($$v) {
        _vm.wakeDateStart = $$v
      },
      expression: "wakeDateStart"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isPreplan) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "id": "selectEndDate"
    },
    model: {
      value: (_vm.menuDateEnd),
      callback: function($$v) {
        _vm.menuDateEnd = $$v
      },
      expression: "menuDateEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select end date",
      "prepend-icon": "event",
      "readonly": "",
      "disabled": _vm.closed
    },
    slot: "activator",
    model: {
      value: (_vm.wakeDateEnd),
      callback: function($$v) {
        _vm.wakeDateEnd = $$v
      },
      expression: "wakeDateEnd"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": "",
      "min": _vm.minEndDate,
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.wakeDateEnd),
      callback: function($$v) {
        _vm.wakeDateEnd = $$v
      },
      expression: "wakeDateEnd"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.selectedServices && _vm.selectedServices.length &&
    _vm.visible.attachServicesToCaseBtn && !_vm.closed) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "",
      "loading": _vm.loading.attachServicesToCaseBtn,
      "disabled": _vm.loading.attachServicesToCaseBtn || !_vm.validated
    },
    on: {
      "click": _vm.attachServicesToCase
    }
  }, [_vm._v("\n        Confirm Order\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.validated) ? _c('v-flex', {
    staticClass: "validation",
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', [_vm._v("Left to fill in:")]), _vm._v(" "), _c('ul', [(!_vm.selectedCasket) ? _c('li', [_c('a', {
    attrs: {
      "href": "#selectCasket"
    }
  }, [_vm._v("Select Casket Model")])]) : _vm._e(), _vm._v(" "), (!_vm.selectedServices) ? _c('li', [_c('a', {
    attrs: {
      "href": "#selectProducts"
    }
  }, [_vm._v("Select Products")])]) : _vm._e(), _vm._v(" "), (!_vm.wakeDateStart) ? _c('li', [_c('a', {
    attrs: {
      "href": "#selectStartDate"
    }
  }, [_vm._v("Select Wake Start Date")])]) : _vm._e(), _vm._v(" "), (!_vm.wakeDateEnd) ? _c('li', [_c('a', {
    attrs: {
      "href": "#selectEndDate"
    }
  }, [_vm._v("Select Wake End Date")])]) : _vm._e()])]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('ConfirmationDialog', {
    ref: "confirm"
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.showAlert),
      callback: function($$v) {
        _vm.showAlert = $$v
      },
      expression: "showAlert"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticClass: "flex-alert-center"
  }, [_c('v-icon', {
    staticClass: "flex-alert-notification-check",
    attrs: {
      "dark": "",
      "right": ""
    }
  }, [_vm._v("check_circle")]), _vm._v(" " + _vm._s(_vm.alertMessage) + "\n      ")], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4255f82d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectPlanAndVendors.vue
// module id = 986
// module chunks = 1